import React, {Component} from 'react';
import FooterData from '../Footer/FooterData';

class Teamitem extends Component {
    render(){
        var {teamImage, memberN, title, socalDataKey }= this.props;
        return(
            <div className="ex_team_item">
                <img src={require ("../../img/" + teamImage)} alt="team"/>
                <div class="text-center" style={{backgroundColor: '#B0CBDC', height: '96px', padding: '2px'}}>
                    <a class="hemdahl-text-dark hemdahl-text-md" href='https://www.linkedin.com/company/hemdahl' >{memberN}</a>
                    <h4 class="hemdahl-text-white">{title}</h4>
                </div>
                <div className="hover_content">
                    <div className="n_hover_content">
                        <ul className="list-unstyled">
                            {
                                FooterData.socialData[socalDataKey].map(item=>{
                                    return(
                                        <li key={item.id}><a href={item.url}><i className={`${item.icon}`}></i></a></li>
                                    )
                                })
                            }
                        </ul>
                        <div className="br"></div>
                        <a href=".#">
                            <h3 className="f_p f_size_16 f_600 w_color">{memberN}</h3>
                        </a>
                        <h5>{title}</h5>
                    </div>
                </div>
            </div>
        )
    }
}
export default Teamitem;